import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useMemo } from 'react';
import { Button, CoverLetterQuickGuide, TextArea, Title } from '../../../';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CoverLetterInputArea = function CoverLetterInputArea(_ref) {
  var onShowCoverLetterGuide = _ref.onShowCoverLetterGuide,
      onApplyWithCoverLetter = _ref.onApplyWithCoverLetter,
      loading = _ref.loading,
      coverLetter = _ref.coverLetter,
      setCoverLetterInput = _ref.setCoverLetterInput,
      _ref$showCoverLetterG = _ref.showCoverLetterGuide,
      showCoverLetterGuide = _ref$showCoverLetterG === void 0 ? true : _ref$showCoverLetterG,
      isError = _ref.isError;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var submitButton = useMemo(function () {
    return /*#__PURE__*/_jsx(Button, {
      title: t('common:send_your_application'),
      variant: 'normal',
      suffixIcon: !coverLetter ? 'RocketLaunchGrayIcon' : 'RocketLaunchPurpleIcon',
      twStyle: {
        "justifyContent": "center",
        "gap": "0.25rem"
      },
      onClick: onApplyWithCoverLetter,
      loading: loading,
      disabled: !coverLetter,
      fullwidth: true
    });
  }, [t, coverLetter, loading, onApplyWithCoverLetter]);
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [showCoverLetterGuide ? /*#__PURE__*/_jsx(_StyledDiv2, {
      children: /*#__PURE__*/_jsx(CoverLetterQuickGuide, {
        showCloseButton: false
      })
    }) : null, /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv4, {
        children: [/*#__PURE__*/_jsxs(_StyledDiv5, {
          children: [/*#__PURE__*/_jsx(Title, {
            content: t('onboarding-page:write_the_cover_letter'),
            fontSize: showCoverLetterGuide ? 'superSuperLarge' : 'extraLarge',
            fontWeight: "semibold",
            twStyle: {
              "maxWidth": "24rem",
              "lineHeight": "1.688rem"
            }
          }), /*#__PURE__*/_jsx(Title, {
            content: t('onboarding-page:write_a_short_presentation'),
            fontSize: "base",
            fontWeight: "normal",
            twStyle: {
              "lineHeight": "1.5rem"
            },
            textColor: "gray"
          })]
        }), /*#__PURE__*/_jsxs(_StyledDiv6, {
          children: [/*#__PURE__*/_jsxs(_StyledDiv7, {
            children: [/*#__PURE__*/_jsx(Title, {
              content: t('onboarding-page:why_are_you_applying'),
              fontSize: "small",
              fontWeight: "medium"
            }), /*#__PURE__*/_jsx(TextArea, {
              id: "cover letter",
              placeholder: t('onboarding-page:write_your_presentation'),
              rows: showCoverLetterGuide ? 13 : 8,
              maxLength: 2024,
              onChange: function onChange(value) {
                return setCoverLetterInput(value);
              },
              value: coverLetter
            }), isError && /*#__PURE__*/_jsx(_StyledDiv8, {
              children: t('common:something_went_wrong')
            })]
          }), showCoverLetterGuide ? submitButton : null]
        })]
      }), !showCoverLetterGuide ? /*#__PURE__*/_jsxs(_StyledDiv9, {
        children: [/*#__PURE__*/_jsx(Button, {
          title: t('onboarding-page:open_the_guide'),
          variant: "secondary-outline",
          icon: "DocumentTextIcon",
          fullwidth: true,
          onClick: onShowCoverLetterGuide
        }), submitButton]
      }) : null]
    })]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv",
  componentId: "sc-7mbc53-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv2",
  componentId: "sc-7mbc53-1"
})({
  "maxWidth": "20rem",
  "borderRightWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
  "paddingRight": "2rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv3",
  componentId: "sc-7mbc53-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "8rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv4",
  componentId: "sc-7mbc53-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem",
  "textAlign": "center",
  "@media (min-width: 768px)": {
    "textAlign": "start"
  }
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv5",
  componentId: "sc-7mbc53-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "alignItems": "flex-start"
  }
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv6",
  componentId: "sc-7mbc53-5"
})({
  "display": "flex",
  "height": "100%",
  "maxHeight": "fit-content",
  "minHeight": "16.313rem",
  "width": "100%",
  "maxWidth": "32rem",
  "flexDirection": "column",
  "gap": "2.5rem",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "1rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv7",
  componentId: "sc-7mbc53-6"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv8",
  componentId: "sc-7mbc53-7"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(204 0 34 / var(--tw-text-opacity))"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv9",
  componentId: "sc-7mbc53-8"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});